import axios from "./axios"
import queryString from "query-string"

export default {
  getFreelancers: async (requestParams) => {
    const search = queryString.stringify(
      { ...requestParams },
      { arrayFormat: "comma", skipEmptyString: true },
    )
    try {
      return await axios.get(`/freelancers?${search}`)
    } catch (error) {
      throw error
    }
  },

  /** id = Upwork external_id (personId) Backend returns profile from cache and materializes Freelancer. */
  getFreelancerProfile: async (id) => {
    try {
      return await axios.get(`/freelancer/${id}`)
    } catch (error) {
      throw error
    }
  },
}
